import config from '../config';

/**
 * Pledge photos — served via /api/pawn/media (works behind admin nginx /api proxy).
 */
export function pawnPhotoUrl(path) {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;

  const normalized = path.startsWith('/') ? path : `/${path}`;
  const match = normalized.match(/\/uploads\/pawn\/([^/?#]+)/i);
  const filename = match ? decodeURIComponent(match[1]) : normalized.split('/').pop();

  if (!filename) return '';

  const apiBase = (config.API_URL || '/api').replace(/\/$/, '');
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${apiBase}/pawn/media/${encodeURIComponent(filename)}`;
  }
  return `${apiBase}/pawn/media/${encodeURIComponent(filename)}`;
}
